// Paste published Gumroad URLs here when the videos are ready. Empty URLs hide
// their purchase links. See docs/gumroad/README.md for the listing and upload kit.
export const SHOP = {
  storefront: 'https://safaelmali.gumroad.com/',   // lists every collection (16 to 21 cities each), so a new one changes nothing here
  // A sale on every collection (the prices themselves are set on Gumroad): a plane tows `banner` across the sky
  // (site/js/ui/plane.js), the link over it says `label`, and the site says `chat` in the chat, in turn with its other
  // posts (site/js/live/chat.js POSTS). It ends by itself at `until` (an ISO time; none: on until it's taken out), so
  // pages opened after it show none of the three, and open tabs ground the plane and drop the post then. null: no sale,
  // no plane, no post.
  sale: {
    banner: '40% OFF · ENDS NOV 30',
    label: '40% off video loops until Nov 30',
    chat: 'Video loops are 40% off until Nov 30, or get all 56 in the Everything bundle',   // SAY_MAX (80) at most
    // Gumroad's CITY40 code (Black Friday / Cyber Monday) expires Nov 30 at 23:59 PST, 07:59 UTC: the site stops then
    // too, never after the code (Gumroad counts the minute itself as expired or not: stopping at its start is the safe side)
    until: '2026-12-01T07:59:00Z',
  },
  cities: {
    paris: '',
    tokyo: '',
    'new-york': '',
    london: '',
    rio: '',
    istanbul: '',
    'hong-kong': '',
    sydney: '',
    'san-francisco': '',
    hamburg: '',
    amsterdam: '',
    dubai: '',
    madrid: '',
    rome: '',
    prague: '',
    munich: '',
    vancouver: '',
    seoul: '',
    bangkok: '',
    'cape-town': '',
    singapore: '',
    'mexico-city': '',
    'new-delhi': '',
    cairo: '',
    lisbon: '',
    osaka: '',
    berlin: '',
    athens: '',
    copenhagen: '',
    seattle: '',
    florence: '',
    dublin: '',
    miami: '',
    budapest: '',
    kyoto: '',
    venice: '',
    marrakech: '',
    'buenos-aires': '',
    chicago: '',
    barcelona: '',
    stockholm: '',
    taipei: '',
    chongqing: '',
    melbourne: '',
    'new-orleans': '',
    toronto: '',
    boston: '',
    'los-angeles': '',
    bali: '',
    'las-vegas': '',
    honolulu: '',
    agra: '',
    'kuala-lumpur': '',
    reykjavik: '',
    havana: '',
    porto: '',
    warsaw: '',
    manila: '',
    portland: '',
    valletta: '',
    almaty: '',
    helsinki: '',
    'ho-chi-minh-city': '',
    auckland: '',
    cartagena: '',
    nairobi: '',
    winnipeg: '',
  },
};

// Accept Gumroad's public HTTPS links; incomplete or mistyped URLs stay hidden.
export function gumroadUrl(value) {
  if (!value) return '';
  try {
    const url = new URL(value);
    const onGumroad = url.hostname === 'gumroad.com' || url.hostname.endsWith('.gumroad.com');
    return url.protocol === 'https:' && onGumroad && !url.username && !url.password ? url.href : '';
  } catch { return ''; }
}

export function shopLinks(city) {
  return { store: gumroadUrl(SHOP.storefront), city: gumroadUrl(SHOP.cities[city]) };
}

/** Whether `sale` (SHOP.sale's) is on at `now` (ms): before its `until`, or for good without one. */
export const saleOn = (sale, now = Date.now()) => !!sale && (!sale.until || now < Date.parse(sale.until));

/** The sale to tell visitors about at `now` ({ banner, label, chat, until }), or null: none, over, or no shop to send them to. */
export const shopSale = (now = Date.now()) => (gumroadUrl(SHOP.storefront) && saleOn(SHOP.sale, now) && SHOP.sale) || null;
